import { useSelector } from 'react-redux'
import styled from 'styled-components'
import { Remarkable } from 'remarkable'

import Content from 'components/Shared/Skeleton/Content/Index'
import * as sessionUserSelector from 'selectors/sessionUser'
import LandingPageImg from 'assets/img/landingPage.svg'
import colors from 'components/utils/colors'

const md = new Remarkable()

const StyledContentSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

const StyledImg = styled.div`
  margin-top: 76px;
  width: 696px;
  display: flex;
  justify-content: center;
`

const Img = styled.div`
  width: 601px;
  height: 385px;
  background: url(${LandingPageImg}) no-repeat;
  background-size: cover;
`

const StyledTitle = styled.div`
  width: 696px;
  margin-top: 66px;
  font-size: 40px;
  color: ${colors.secondary20};
  text-align: left;
  line-height: 52px;
  font-family: Exo;
  font-weight: 300;
`

const StyledText = styled.div`
  width: 696px;
  margin-top: 10px;
  font-size: 14px;
  color: ${colors.secondary20};
  text-align: justify;
  line-height: 19px;
  font-weight: 500;
`

const LandingPage = () => {
  const landingPageTitle = useSelector(sessionUserSelector.landingPageTitle)
  const landingPageText = useSelector(sessionUserSelector.landingPageText)
  const renderMarkdown = (source) => <div dangerouslySetInnerHTML={{ __html: md.render(source) }} />

  return (
    <Content>
      <StyledContentSection>
        <StyledImg>
          <Img />
        </StyledImg>
        <StyledTitle>
          {landingPageTitle}
        </StyledTitle>
        <StyledText>
          {renderMarkdown(landingPageText)}
        </StyledText>
      </StyledContentSection>
    </Content>
  )
}

export default LandingPage
